(function () {
  'use strict';

  class FrequentlyBoughtTogether {
    constructor(root) {
      this.root = root;
      this.abortController = new AbortController();
      this.cards = Array.from(this.root.querySelectorAll('[data-fbt-card]'));
      this.checkboxes = Array.from(this.root.querySelectorAll('[data-fbt-checkbox]'));
      this.totalElement = this.root.querySelector('[data-fbt-total]');
      this.wasElement = this.root.querySelector('[data-fbt-was]');
      this.saveElement = this.root.querySelector('[data-fbt-save]');
      this.saveTextElement = this.root.querySelector('[data-fbt-save-text]');
      this.addButton = this.root.querySelector('[data-fbt-add]');
      this.message = this.root.querySelector('[data-fbt-message]');
      this.buttonTemplate = this.root.dataset.buttonTemplate || 'Add [count] to cart';
      this.emptyLabel = this.root.dataset.emptyLabel || 'Select a product';
      this.discountPercent = Number(this.root.dataset.discountPercent || 0);
      this.discountMin = Number(this.root.dataset.discountMin || 3);
      this.saveTemplate = this.root.dataset.saveTemplate || 'You save [amount] · [percent]% off';
      /* Model pair discount (automatic discount for two of this product), in shop currency. */
      this.pairAmount = Number(this.root.dataset.pairAmount || 0);
      this.pairSaveTemplate = this.root.dataset.pairSaveTemplate || 'You save [amount]';
      this.pairNoteTemplate = this.root.dataset.pairNoteTemplate || '';
      this.shippingElement = this.root.querySelector('[data-fbt-shipping]');
      this.shippingTextElement = this.root.querySelector('[data-fbt-shipping-text]');
      this.shippingThreshold = Number(this.root.dataset.shippingThreshold || 0);
      this.shippingActiveText = this.root.dataset.shippingActiveText || 'Free Worldwide Shipping activated';
      this.shippingProgressText = this.root.dataset.shippingProgressText || 'Add [amount] more for free worldwide shipping';
      this.currency = this.root.dataset.currency || 'USD';
      this.locale = this.root.dataset.locale || document.documentElement.lang || navigator.language || 'en';
      this.connected = this.root.dataset.connected === 'true';
      this.mainTitle = this.root.dataset.mainTitle || '';
      this.recapElement = this.root.querySelector('[data-fbt-recap]');
      const mainSubmit = document.querySelector('[data-petspemf-submit]');
      this.mainSection = this.connected && mainSubmit ? mainSubmit.closest('[data-section-id]') : null;
      this.mainForm = this.connected && mainSubmit ? mainSubmit.closest('form') : null;
      this.mainPrices = {};
      if (this.mainSection) {
        const priceMapEl = this.mainSection.querySelector('[data-petspemf-addon-prices]');
        if (priceMapEl) { try { this.mainPrices = JSON.parse(priceMapEl.textContent); } catch (error) { this.mainPrices = {}; } }
      }

      this.onCheckboxChange = this.onCheckboxChange.bind(this);
      this.onAddClick = this.onAddClick.bind(this);

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.onCheckboxChange, { signal: this.abortController.signal });
      });

      if (this.addButton) {
        this.addButton.addEventListener('click', this.onAddClick, { signal: this.abortController.signal });
      }

      this.bindVariantCards();
      this.bindConnectedForm();
      this.bindMainVariantSync();
      this.render();
    }

    destroy() {
      this.abortController.abort();
    }

    /*
      Keeps the "This item" card in sync with the variant radios in the
      petspemf-product-main section (Small pad / Large pad), so the bundle
      adds the size the customer actually selected.
    */
    bindMainVariantSync() {
      this.mainCard = this.root.querySelector('[data-fbt-main]');
      if (!this.mainCard) return;

      const variantRadios = Array.from(document.querySelectorAll('input[type="radio"][name="id"][data-petspemf-variant]'));
      if (!variantRadios.length) return;

      const sync = (radio) => {
        this.mainCard.dataset.variantId = radio.value;
        const checkbox = this.mainCard.querySelector('[data-fbt-checkbox]');
        if (checkbox) checkbox.value = radio.value;

        if (radio.dataset.priceCents) {
          this.mainCard.dataset.price = radio.dataset.priceCents;
          const priceElement = this.mainCard.querySelector('[data-fbt-main-price]');
          if (priceElement) priceElement.textContent = this.formatMoney(Number(radio.dataset.priceCents));
        }

        this.render();
      };

      variantRadios.forEach((radio) => {
        radio.addEventListener('change', () => sync(radio), { signal: this.abortController.signal });
      });

      const checkedRadio = variantRadios.find((radio) => radio.checked);
      if (checkedRadio) sync(checkedRadio);
    }

    /* Variant cross-sell: show the card for the model the customer did NOT
       pick; swap live when the selection changes. */
    bindVariantCards() {
      this.variantSlots = Array.from(this.root.querySelectorAll('[data-fbt-variant-slot]'));
      if (!this.variantSlots.length) return;
      const submitButton = document.querySelector('[data-petspemf-submit]');
      const form = submitButton ? submitButton.closest('form') : null;
      if (!form) return;
      const update = () => {
        const input = form.querySelector('[name="id"]:checked') || form.querySelector('input[name="id"]');
        const selectedId = input ? String(input.value) : null;
        this.variantSlots.forEach((slot) => {
          const hide = slot.dataset.fbtVariantSlot === selectedId;
          if (hide === slot.hidden) return;
          slot.hidden = hide;
          const checkbox = slot.querySelector('[data-fbt-checkbox]');
          const card = slot.querySelector('[data-fbt-card]');
          if (checkbox && !checkbox.disabled) {
            checkbox.checked = !hide;
            if (card) {
              card.classList.toggle('is-selected', checkbox.checked);
              card.classList.toggle('is-unselected', !checkbox.checked);
            }
          }
        });
        this.render();
      };
      form.addEventListener('change', update, { signal: this.abortController.signal });
      update();
    }

    /* Connected mode: the section's button also adds the main product and
       the buy-box add-ons, so the whole page acts as one bundle. */
    bindConnectedForm() {
      if (!this.connected || !this.mainForm) return;
      this.mainForm.addEventListener('change', () => this.render(), { signal: this.abortController.signal });
    }

    getMainItem() {
      if (!this.connected || !this.mainForm) return null;
      const input = this.mainForm.querySelector('[name="id"]:checked') || this.mainForm.querySelector('input[name="id"]');
      if (!input || !input.value) return null;
      const mapped = this.mainPrices[input.value];
      const radioPrice = input.dataset && input.dataset.priceCents ? Number(input.dataset.priceCents) : 0;
      let variantLabel = '';
      if (this.mainSection) {
        const axisRadio = this.mainSection.querySelector('[data-petspemf-variant]:checked');
        if (axisRadio && axisRadio.dataset.option1) {
          variantLabel = axisRadio.dataset.option1;
        } else {
          const picked = Array.from(this.mainSection.querySelectorAll('input[data-petspemf-opt1]:checked, input[data-petspemf-opt2]:checked')).map((radio) => radio.value);
          if (picked.length) variantLabel = picked.join(' / ');
        }
      }
      const label = this.mainTitle + (variantLabel ? ' \u2014 ' + variantLabel : '');
      // Use the same complete variant title as the main buy button, including
      // multi-option devices. Read it on each click so variant changes stay current.
      let coverageVariant = variantLabel;
      const titlesElement = this.mainSection && this.mainSection.querySelector('[data-petspemf-variant-titles]');
      if (titlesElement) {
        try {
          const titles = JSON.parse(titlesElement.textContent);
          if (Object.prototype.hasOwnProperty.call(titles, input.value)) coverageVariant = titles[input.value];
        } catch (error) { /* Fall back to the selected options above. */ }
      }
      const coverageLabel = this.mainTitle + (coverageVariant && coverageVariant !== 'Default Title' ? ' (' + coverageVariant + ')' : '');
      return { id: Number(input.value), price: mapped != null ? Number(mapped) : radioPrice, label: label, coverageLabel: coverageLabel };
    }

    getBuyboxItems() {
      if (!this.connected || !this.mainSection) return [];
      const mainItem = this.getMainItem();
      if (!mainItem) return [];
      return Array.from(this.mainSection.querySelectorAll('.petspemf-addons__check[data-variant-id]:checked'))
        .map((checkbox) => {
          const row = checkbox.closest('.petspemf-addons__item');
          const nameElement = row ? row.querySelector('.petspemf-addons__name') : null;
          return {
            id: Number(checkbox.dataset.variantId),
            price: Number(checkbox.dataset.price) || 0,
            properties: { For: checkbox.dataset.coverageLabel || mainItem.coverageLabel },
            label: nameElement ? nameElement.textContent.trim() : '',
          };
        });
    }

    onCheckboxChange(event) {
      const card = event.target.closest('[data-fbt-card]');

      if (!card || card.dataset.available !== 'true') return;

      card.classList.toggle('is-selected', event.target.checked);
      card.classList.toggle('is-unselected', !event.target.checked);
      this.hideMessage();
      this.render();
    }

    getSelectedCards() {
      return this.cards.filter((card) => {
        if (this.connected && card.hasAttribute('data-fbt-main')) return false;
        const checkbox = card.querySelector('[data-fbt-checkbox]');
        return card.dataset.available === 'true' && checkbox && checkbox.checked;
      });
    }

    /* Pair discount per model in the presentment currency (Shopify converts fixed
       discount amounts with the storefront rate). */
    pairMinor() {
      if (!(this.pairAmount > 0)) return 0;
      const rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
      return Math.round(this.pairAmount * 100 * rate);
    }

    renderPairCards() {
      const pair = this.pairMinor();
      this.root.querySelectorAll('[data-fbt-variant-card]').forEach((card) => {
        const price = Number(card.dataset.price || 0);
        const priceEl = card.querySelector('[data-fbt-variant-price]');
        const wasEl = card.querySelector('[data-fbt-variant-was]');
        const badge = card.querySelector('[data-fbt-pair-badge]');
        const note = card.querySelector('[data-fbt-pair-note]');
        const on = pair > 0 && price > 0;
        if (priceEl) priceEl.textContent = this.formatMoney(on ? Math.max(0, price - pair) : price);
        if (wasEl) { wasEl.textContent = on ? this.formatMoney(price) : ''; wasEl.hidden = !on; }
        if (badge) { badge.textContent = on ? 'SAVE ' + this.formatMoney(pair) : ''; badge.hidden = !on; }
        if (note) {
          note.textContent = on && this.pairNoteTemplate ? this.pairNoteTemplate.replace('[amount]', this.formatMoney(pair)) : '';
          note.hidden = !(on && this.pairNoteTemplate);
        }
      });
    }

    render() {
      const selectedCards = this.getSelectedCards();
      const mainItem = this.connected ? this.getMainItem() : null;
      const extras = this.connected ? [mainItem].concat(this.getBuyboxItems()).filter(Boolean) : [];
      const selectedCount = selectedCards.length + extras.length;
      const subtotal = selectedCards.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0)
        + extras.reduce((sum, item) => sum + item.price, 0);

      this.renderRecap(selectedCards, extras);
      this.renderPairCards();

      /* Lines as the cart prices them. On the Advanced plan a line gets one product
         discount, the larger one: the model pair amount (two or more models of this
         product in the cart) or the bundle percent (enough items selected). */
      const pair = this.pairMinor();
      const lines = extras.map((item) => ({ price: item.price, model: pair > 0 && item === mainItem }))
        .concat(selectedCards.map((card) => ({ price: Number(card.dataset.price || 0), model: pair > 0 && card.hasAttribute('data-fbt-variant-card') })));
      const pairActive = pair > 0 && lines.filter((line) => line.model).length >= 2;
      const bundleActive = this.discountPercent > 0 && selectedCount >= this.discountMin;
      const total = lines.reduce((sum, line) => {
        const pairOff = pairActive && line.model ? Math.min(pair, line.price) : 0;
        const bundleOff = bundleActive ? Math.round(line.price * this.discountPercent / 100) : 0;
        return sum + line.price - Math.max(pairOff, bundleOff);
      }, 0);
      const discountActive = total < subtotal;

      if (this.totalElement) {
        this.totalElement.textContent = this.formatMoney(total);
      }

      if (this.wasElement) {
        this.wasElement.textContent = discountActive ? this.formatMoney(subtotal) : '';
        this.wasElement.hidden = !discountActive;
      }

      if (this.saveElement && this.saveTextElement) {
        if (discountActive && pairActive) {
          this.saveTextElement.textContent = this.pairSaveTemplate.replace('[amount]', this.formatMoney(subtotal - total));
        } else if (discountActive) {
          this.saveTextElement.textContent = this.saveTemplate
            .replace('[amount]', this.formatMoney(subtotal - total))
            .replace('[percent]', String(this.discountPercent));
        }
        this.saveElement.hidden = !discountActive;
      }

      this.updateShipping(total);

      if (!this.addButton) return;

      if (selectedCount === 0) {
        this.addButton.textContent = this.emptyLabel;
        this.addButton.disabled = true;
      } else {
        this.addButton.textContent = this.buttonTemplate.replace('[count]', String(selectedCount));
        this.addButton.disabled = false;
      }
    }

    renderRecap(selectedCards, extras) {
      if (!this.recapElement) return;
      if (!this.connected) { this.recapElement.hidden = true; return; }
      const rows = [];
      extras.forEach((item) => rows.push({ name: item.label || '', price: item.price }));
      selectedCards.forEach((card) => {
        const title = card.querySelector('.frequently-bought-together__title');
        rows.push({ name: title ? title.textContent.trim() : '', price: Number(card.dataset.price || 0) });
      });
      this.recapElement.innerHTML = '';
      rows.forEach((row) => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        name.className = 'frequently-bought-together__recap-name';
        name.textContent = row.name;
        const price = document.createElement('span');
        price.className = 'frequently-bought-together__recap-price';
        price.textContent = this.formatMoney(row.price);
        item.appendChild(name);
        item.appendChild(price);
        this.recapElement.appendChild(item);
      });
      this.recapElement.hidden = rows.length === 0;
    }

    updateShipping(total) {
      if (!this.shippingElement || !this.shippingTextElement) return;
      if (!this.shippingThreshold || total <= 0) {
        this.shippingElement.hidden = true;
        return;
      }

      /* Threshold is set in the shop currency, bundle prices render in the presentment
         currency, so convert with the storefront rate before comparing. */
      const rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 1;
      const thresholdMinor = Math.round(this.shippingThreshold * 100 * rate);
      const reached = total >= thresholdMinor;

      this.shippingTextElement.textContent = reached
        ? this.shippingActiveText
        : this.shippingProgressText.replace('[amount]', this.formatMoney(thresholdMinor - total));
      this.shippingElement.classList.toggle('is-active', reached);
      this.shippingElement.hidden = false;
    }

    formatMoney(minorUnits) {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
        }).format(minorUnits / 100);
      } catch (error) {
        return (minorUnits / 100).toFixed(2);
      }
    }

    getCartAddUrl() {
      if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;

      const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

      return `${shopifyRoot}cart/add.js`;
    }

    async onAddClick() {
      const selectedCards = this.getSelectedCards();
      const extras = this.connected ? [this.getMainItem()].concat(this.getBuyboxItems()).filter(Boolean) : [];
      if ((!selectedCards.length && !extras.length) || !this.addButton) return;

      this.setLoading(true);
      this.hideMessage();

      const cartDrawer = document.querySelector('cart-drawer');
      const payload = {
        items: extras.map((item) => ({ id: item.id, quantity: 1, ...(item.properties ? { properties: item.properties } : {}) })).concat(
          selectedCards.map((card) => ({
            id: Number(card.dataset.variantId),
            quantity: 1,
          }))
        ),
      };

      /*
        Theme-specific cart drawer integration:
        This Dawn-derived theme exposes cartDrawer.getSectionsToRender() and
        cartDrawer.renderContents(response). If another theme uses different
        drawer APIs, this is the only integration point that may need adjustment.
      */
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');
        payload.sections_url = window.location.pathname;

        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(document.activeElement);
        }
      }

      try {
        const response = await fetch(this.getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        });
        const parsedState = await response.json();

        if (!response.ok || parsedState.status) {
          throw new Error(parsedState.description || parsedState.message || window.cartStrings?.error || 'Unable to add items to cart.');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'frequently-bought-together',
            cartData: parsedState,
          });
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections) {
          cartDrawer.renderContents(parsedState);
        } else {
          window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        }
      } catch (error) {
        this.showMessage(error.message);
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      if (!this.addButton) return;

      this.addButton.classList.toggle('is-loading', isLoading);
      this.addButton.disabled = isLoading;

      if (!isLoading) {
        this.render();
      }
    }

    showMessage(text) {
      if (!this.message) return;

      this.message.textContent = text;
      this.message.hidden = false;
    }

    hideMessage() {
      if (!this.message) return;

      this.message.textContent = '';
      this.message.hidden = true;
    }
  }

  function initFrequentlyBoughtTogether(scope = document) {
    const roots = scope.matches && scope.matches('[data-fbt-section]')
      ? [scope]
      : Array.from(scope.querySelectorAll('[data-fbt-section]'));

    roots.forEach((root) => {
      if (root.frequentlyBoughtTogether) {
        root.frequentlyBoughtTogether.destroy();
      }

      root.frequentlyBoughtTogether = new FrequentlyBoughtTogether(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initFrequentlyBoughtTogether());
  document.addEventListener('shopify:section:load', (event) => initFrequentlyBoughtTogether(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-fbt-section]');
    if (root && root.frequentlyBoughtTogether) {
      root.frequentlyBoughtTogether.destroy();
    }
  });
})();

(function () {
  if (window.__fbtQuickviewBound) return;
  window.__fbtQuickviewBound = true;
  var openQv = null;
  function closeQv() {
    if (!openQv) return;
    openQv.hidden = true;
    document.body.style.overflow = '';
    openQv = null;
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-fbt-learn]');
    if (link) {
      var qv = document.querySelector('[data-fbt-quickview="' + link.getAttribute('data-fbt-learn') + '"]');
      if (qv) {
        event.preventDefault();
        event.stopPropagation();
        qv.hidden = false;
        document.body.style.overflow = 'hidden';
        openQv = qv;
        var closeBtn = qv.querySelector('.fbt-quickview__close');
        if (closeBtn) closeBtn.focus();
      }
      return;
    }
    if (event.target.closest('[data-fbt-qv-close]')) {
      event.preventDefault();
      closeQv();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeQv();
  });
})();
